module.exports = __webpack_public_path__ + "static/img/5.4d4ceae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Infidelidad-Riesgos-Financieros/5.png
// module id = QjFE
// module chunks = 0